import moment from 'moment'
import { validCIF } from 'spain-id'

export default {
  data () {
    return {
    }
  },
  computed: {
    rules () {
      return {
        required: v => (v !== null && v !== undefined && v !== '' && (!Array.isArray(v) || v.length > 0)) || this.$t('mixins.rules.campoObligatorio'),
        requiredIf: n => n === false || (v => (v !== null && v !== undefined && v !== '' && (!Array.isArray(v) || v.length > 0)) || this.$t('mixins.rules.campoObligatorio')),
        checkboxSelected: v => v === true || this.$t('mixins.rules.campoObligatorio'),
        email: v => this.validadorMail(v) || this.$t('mixins.rules.emailIncorrecto'),
        emailOpcional: v => (this.esVacio(v) || this.validadorMail(v)) || this.$t('mixins.rules.emailIncorrecto'),
        date: v => moment(v).isValid() || this.$t('mixins.rules.formatoIncorrecto'),
        obligatorio: v => !!v || this.$t('mixins.rules.campoObligatorio'),
        min: n => v => v == null || v.length >= n || this.$tc('mixins.rules.min',n,{count: n}),
        max: n => v => v == null || v.length <= n || this.$tc('mixins.rules.max',n,{count: n}),
        menor: n => v => (v == null || (this.removeDecimalInput(v) < n)) || this.$t('mixins.rules.valorMenor', {count: n}),
        menorIgual: n => v => (v == null || (this.removeDecimalInput(v) <= n)) || this.$t('mixins.rules.valorMenorIgual', {count: n}),
        mayor: n => v => (v == null || (this.removeDecimalInput(v) > n)) || this.$t('mixins.rules.valorMayor', {count: n}),
        mayorIgual: n => v => (v == null || (this.removeDecimalInput(v) >= n)) || this.$t('mixins.rules.valorMayorIgual', {count: n}),
        porcentaje: v => (v == null || (this.removeDecimalInput(v) > 0 && this.removeDecimalInput(v) <= 100)) || this.$t('mixins.rules.valorEntre'),
        precioNumber: v => (this.esVacio(v) || /^\d((\d{0,2}(\.\d{3})*)+(,\d+)?)$/.test(v)) || this.$t('mixins.rules.formatoIncorrecto'),
        integerNumberPuntos: v => (this.esVacio(v) || /^\d((\d{0,2}(\.\d{3})*))$/.test(v)) || this.$t('mixins.rules.formatoIncorrecto'),
        integerNumber: v => (this.esVacio(v) || /^0*(?:[1-9]|[1-9]\d\d*)$/.test(v)) || this.$t('mixins.rules.formatoIncorrecto'),
        integerNumber0: v => (this.esVacio(v) || /^0*(?:[0-9]|[0-9]\d\d*)$/.test(v)) || this.$t('mixins.rules.formatoIncorrecto'),
        numberUppercase: v => (this.esVacio(v) || /^[0-9A-Z]+$/.test(v)) || this.$t('mixins.rules.soloNumYMayusculas'),
        validarNif: n => v => (this.esVacio(v) || ((n === 'N' || n === 'C') ? this.validadorNIF(v) : true)) || this.$t('mixins.rules.numDocNoValido'),
        validarIf: (m, f) => m ? f : () => true,
        validarNifOEmail: v => (this.esVacio(v) || this.validadorNIF(v) || this.validadorMail(v)) || this.$t('mixins.rules.numDocEmailNoValido'),
        validarCif: n => v => (this.esVacio(v) || ((n === 'C') ? this.validadorCIF(v) : true)) || this.$t('mixins.rules.numDocNoValido'),
        noSoloEspacios: v => !this.soloEspacios(v) || this.$t('mixins.rules.soloEspacios')
      }
    }
  },
  methods:
  {
    esVacio (v) {
      return (v === null || v === '' || v === undefined)
    },
    soloEspacios (v) {
      if (v == null) {
        return true
      }
      let aux = true
      Array.from(v).forEach(element => {
        if (element !== ' ') {
          aux = false
        }
      })
      return aux
    },
    validadorMail (v) {
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)
    },
    validadorDNI (v) {
      return /^(\d{7,8})([A-HJ-NP-TV-Z])$/.test(v) && ('TRWAGMYFPDXBNJZSQVHLCKE'[(RegExp.$1 % 23)] === RegExp.$2)
    },
    validadorCIF (v) {
      return validCIF(v)
    },
    validadorNIF (v) {
      // Quitamos el primer caracter y el ultimo digito
      let valueCif = v.substr(1, v.length - 2)
      let suma = 0
      // Sumamos las cifras pares de la cadena
      for (let i = 1; i < valueCif.length; i += 2) {
        suma = suma + parseInt(valueCif.substr(i, 1))
      }
      let suma2 = 0
      // Sumamos las cifras impares de la cadena
      for (let i = 0; i < valueCif.length; i += 2) {
        let result = parseInt(valueCif.substr(i, 1)) * 2
        if (String(result).length === 1) {
          // Un solo caracter
          suma2 = suma2 + parseInt(result)
        } else {
          // Dos caracteres. Los sumamos...
          suma2 = suma2 + parseInt(String(result).substr(0, 1)) + parseInt(String(result).substr(1, 1))
        }
      }

      // Sumamos las dos sumas que hemos realizado
      suma = suma + suma2
      let unidad = String(suma).substr(1, 1)
      unidad = 10 - parseInt(unidad)
      var primerCaracter = v.substr(0, 1).toUpperCase()

      if (primerCaracter.match(/^[FJKNPQRSUVW]$/)) {
        // Empieza por .... Comparamos la ultima letra
        if (String.fromCharCode(64 + unidad).toUpperCase() === v.substr(v.length - 1, 1).toUpperCase()) {
          return true
        }
      } else if (primerCaracter.match(/^[XYZ]$/)) {
        // Se valida como un dni
        let newcif
        if (primerCaracter === 'X') {
          newcif = v.substr(1)
        } else if (primerCaracter === 'Y') {
          newcif = '1' + v.substr(1)
        } else if (primerCaracter === 'Z') {
          newcif = '2' + v.substr(1)
        }
        return this.validadorDNI(newcif)
      } else if (primerCaracter.match(/^[ABCDEFGHLM]$/)) {
        // Se revisa que el ultimo valor coincida con el calculo
        if (unidad === 10) {
          unidad = 0
        }
        if (v.substr(v.length - 1, 1) === String(unidad)) {
          return true
        }
      } else {
        // Se valida como un dni
        return this.validadorDNI(v)
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/rules.js